import React from "react"
import Layout from "../components/Layout.js"
import Hero from "../components/estimate/Hero.js"
import EstimateCosts from "../components/estimate/EstimateCosts.js"
import Faq from "../components/pricing/Faq.js"
import Footer from "../components/index/Footer.js"
import FooterContact from "../components/index/FooterContact.js"

export default () => (
  <Layout>
    <Hero />
    <EstimateCosts />
    <Faq />
    <FooterContact />
    <Footer />
  </Layout>
)
